import{isUrlParam as r}from"../UrlParam/UrlParam.js";var a=function(a){return a instanceof Array&&a.every(r)};export{a as areUrlParams};
//# sourceMappingURL=UrlParams.js.map
